import backend from '@common/backend';
import { ITableDataQuery } from '@common/models/TableData';

const BASE = '/cgSchools';

type BaseID = number | 'string';

export interface ICreateCgSchool {
	name: string;
	c_g_city_id?: number;
	custom_city_name?: string;
	c_g_coordinator_ids?: string[];
}

interface IUpdateСities {
	id: BaseID;
	payload: ICreateCgSchool;
}

export const getCgSchools = async (query?: ITableDataQuery) =>
	backend.get(`${BASE}`, {
		params: {
			...query,
		},
	});

export const createCgSchool = async (paylod: ICreateCgSchool) => backend.post(`${BASE}`, paylod);

export const getCgSchool = async ({ id }: { id: BaseID }) => backend.get(`${BASE}/${id}`);

export const getCgSchoolStats = async () => backend.get(`${BASE}/stats`);

export const updateCgSchool = async ({ id, payload }: IUpdateСities) =>
	backend.put(`${BASE}/${id}`, payload);

export const deleteCgSchool = async ({ id }: { id: BaseID }) => backend.delete(`${BASE}/${id}`);

export const getRiasecStats = async () => backend.get(`${BASE}/riasecStats`);
